import React from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { NextUpComponentStyle } from '../../../styles/NextUpComponentStyle';
import clsx from 'clsx';

/**
 * @param cardTitle Title of the next up card.
 * @param cardText Text of the next up card.
 * @param cardImage Image of the next up card.
 * @param linkText Text used in the link associated with next up card (optional).
 * @param onclick Function called when the link is clicked (optional).
 */
export default function NextUpComponent({ cardTitle, cardText, CardImage, linkText, onClick, cardMediaBoxFlexStyle, wrapToImage = false }) {
    const classes = NextUpComponentStyle();

    function UnwrappedNextUpContent() {
        return (
            <>
                <CardContent
                    classes={{
                        root: classes.cardContentRoot,
                    }}
                >
                    <Typography variant="subtitle1">{cardTitle}</Typography>
                    <Typography variant="body1" className={classes.cardText}>
                        {cardText}
                    </Typography>
                </CardContent>
                <Box
                    component="div"
                    className={clsx(classes.cardMediaBox, {
                        [classes.cardMediaBoxFlexStyle]: cardMediaBoxFlexStyle,
                    })}
                >
                    <CardMedia component={CardImage} aria-labelledby="next up logo" title="next up logo" />
                </Box>
            </>
        )
    }

    function WrappedNextUpContent() {
        return (
            <CardContent
                classes={{
                    root: classes.wrappedCardContentRoot,
                }}
            >
                <div className={classes.wrappedContainer}>
                    <div className={classes.wrappedContainerFlexChild}>
                        
                        <div className={clsx({ [classes.floatedImage]: wrapToImage})}>
                            <CardMedia component={CardImage} aria-labelledby="next up logo" title="next up logo" />
                        </div>

                        <Typography className={classes.subtitle} variant="subtitle1">{cardTitle}</Typography>

                        <Typography variant="body1" className={clsx(classes.cardText, classes.wrappedContainerBodyText)}>
                            {cardText}
                        </Typography>

                    </div>
                </div>
            </CardContent>
        )
    }
    return (
        <Box component="div" display="flex" flexDirection="column" justifyContent="flex-start" className={classes.nextUpBox}>
            <Typography data-cy="label_next_up" variant="h2" className={classes.H2}>
                Next Up
            </Typography>
            <Card data-cy="card_next_up" elevation={0} className={classes.roundedBorder}>
                <Box component="div" display="flex" flexDirection="row" justifyContent="space-between" className={classes.card}>
                    { wrapToImage ? WrappedNextUpContent() : UnwrappedNextUpContent() }
                </Box>
            </Card>
            {linkText && (
                <Typography variant="body1" onClick={onClick} className={classes.linkStyle}>
                    {linkText}
                </Typography>
            )}
        </Box>
    );
}
